import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { SunglassesRxableSelect } from './SunglassesRxableSelect.js';
import { WITHOUT_RX, WITH_RX } from './types.js';

const SunglassesRxableSelectContainer = (props)=>{
    const { getLabel  } = useIntl();
    const radioButtonItems = React__default.useMemo(()=>[
            {
                value: WITHOUT_RX,
                label: getLabel('products.selectRxAble.withoutRx'),
                iconName: 'sunglasses'
            },
            {
                value: WITH_RX,
                label: getLabel('products.selectRxAble.withRx'),
                iconName: 'store-eye-test'
            }, 
        ]
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(SunglassesRxableSelect, swcHelpers.extends({
        items: radioButtonItems
    }, props));
};

export { SunglassesRxableSelectContainer };
//# sourceMappingURL=SunglassesRxableSelectContainer.js.map
